import React, { useEffect, useRef, useState } from 'react';
import { generateQRDataURL } from '../../utils/qrGenerator';

export default function QRCodeDisplay({ value, size = 160, className = '' }) {
  const [dataUrl, setDataUrl] = useState(null);

  useEffect(() => {
    if (!value) return;
    generateQRDataURL(value, size).then(setDataUrl).catch(() => setDataUrl(null));
  }, [value, size]);

  if (!dataUrl) {
    return (
      <div
        className={`flex items-center justify-center bg-slate-50 border border-slate-200 rounded-2xl ${className}`}
        style={{ width: size, height: size }}
      >
        <div className="w-8 h-8 border-2 border-sky-200 border-t-sky-500 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <img
      src={dataUrl}
      alt="QR Code"
      className={`rounded-2xl border border-slate-200 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
